import "./widget.scss";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import useFetch from "../../hooks/useFetch";
import { useEffect, useState } from "react";

const Widget = ({ type }) => {
  const  usersData = useFetch(`/users`);
  const bookingData = useFetch(`/rooms/booking/:id`);


  console.log("bookingData?.data=>", bookingData?.data);

  console.log("bookingData?.data?.length=>", bookingData?.data?.length);

  var count =0
  var earnings = bookingData.data.map((item, i) => {
 return  count+=item.amount
})


  let data2;
  const diff = 20;

  switch (type) {
    case "user":
      data2 = {
        title: "USERS",
        isMoney: false,
        link: "See all users",
        total: usersData?.data?.length,
        icon: (
          <PersonOutlinedIcon
            className="icon"
            style={{
              color: "crimson",
              backgroundColor: "rgba(255, 0, 0, 0.2)",
            }}
          />
        ),
      };
      break;
    case "order":
      data2 = {
        title: "BOOKNGS",
        isMoney: false,
        link: "View all orders",
        total: bookingData?.data?.length,
        icon: (
          <ShoppingCartOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(218, 165, 32, 0.2)",
              color: "goldenrod",
            }}
          />
        ),
      };
      break;
    case "earning":
      data2 = {
        title: "EARNINGS",
        isMoney: true,
        link: "View net earnings",
        total: count?count+"$":0+"$",
        icon: (
          <MonetizationOnOutlinedIcon
            className="icon"
            style={{ backgroundColor: "rgba(0, 128, 0, 0.2)", color: "green" }}
          />
        ),
      };
      break;
    default:
      break;
  }

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data2.title}</span>
        <span className="counter">{data2.total}</span>
        <span className="link">{data2.link}</span>
      </div>
      <div className="right">
        <div className="percentage positive">
          <KeyboardArrowUpIcon />
          {diff} %
        </div>
        {data2.icon}
      </div>
    </div>
  );
};

export default Widget;
